import { getLanguage } from '../i18n';

const messages = {
  en: {
    edit: 'Edit note', metadata: 'Note information', title: 'Name', description: 'Description', optional: 'Optional',
    difficulty: 'Difficulty', unspecified: 'Not specified', cover: 'Cover image', source: 'Source', author: 'Author',
    personal: 'Custom', official: 'Official library', market: 'Market', you: 'You', sourceUnknown: 'Original author',
    cards: 'Cards', empty: 'No cards yet. Add a card or append cards from text.', append: 'Append text cards',
    appendHelp: 'Pasted text adds new cards only. Existing cards are edited individually and keep their learning records.',
    editCard: 'Edit card', deleteCard: 'Delete card', deleteTitle: 'Delete this card?',
    deleteHelp: 'The card and its learning record will be deleted when you save. Cancel editing to keep them.',
    remove: 'Delete from draft', changes: 'Review changes', added: 'Added', modified: 'Modified', deleted: 'Deleted',
    unchanged: 'No card content changes.', save: 'Save changes', cardsRequired: 'Add at least one card.',
    nameRequired: 'Enter a note name.', descriptionRequired: 'Market listings require a description.',
    difficultyRequired: 'Select a difficulty from 1 to 5.', cardLimit: 'A note can contain up to 200 cards.',
    lockedLocales: 'The languages of an existing personal note cannot be changed.',
    detect: 'Suggest languages', detecting: 'Detecting languages…', defaultLocale: 'Some languages could not be detected. Your current selections have been kept; please check them.',
    saveFailed: 'Could not save. Your draft has been kept; please try again.',
    pendingText: 'Append the text cards before saving, or clear the text field.',
    loadFailed: 'Could not load this note.', retry: 'Try again', editHelp: 'Edit content without resetting points or repetition counts.',
    appendOnly: 'Add cards to this note. Existing content and note settings stay unchanged.',
    cancelTitle: 'Discard these changes?', cancelHelp: 'Unsaved edits will be lost. Your saved note will not change.',
    discard: 'Discard changes', keepEditing: 'Keep editing', confirmSave: 'Confirm and save',
    noDescription: 'No description', coverChanged: 'Selected cover will be saved', coverRemoved: 'The current cover will be removed',
  },
  ko: {
    edit: '노트 편집', metadata: '노트 정보', title: '이름', description: '설명', optional: '선택 사항',
    difficulty: '난이도', unspecified: '미지정', cover: '표지 이미지', source: '출처', author: '작성자',
    personal: '커스텀', official: '공식 라이브러리', market: '마켓', you: '나', sourceUnknown: '원본 작성자',
    cards: '카드', empty: '아직 카드가 없습니다. 카드를 하나 만들거나 텍스트로 여러 장 추가해 보세요.', append: '텍스트 포맷으로 카드 추가',
    appendHelp: '붙여넣은 텍스트는 새 카드로 추가됩니다. 기존 카드는 개별 편집하며 학습 기록을 유지합니다.',
    editCard: '카드 편집', deleteCard: '카드 삭제', deleteTitle: '이 카드를 삭제할까요?',
    deleteHelp: '저장하면 이 카드와 학습 기록이 함께 삭제됩니다. 편집을 취소하면 유지됩니다.',
    remove: '초안에서 삭제', changes: '변경 사항 확인', added: '추가', modified: '수정', deleted: '삭제',
    unchanged: '카드 내용 변경 없음', save: '변경 사항 저장', cardsRequired: '카드를 한 장 이상 추가해 주세요.',
    nameRequired: '노트 이름을 입력해 주세요.', descriptionRequired: '마켓에 공개할 노트에는 설명이 필요합니다.',
    difficultyRequired: '1부터 5까지의 난이도를 선택해 주세요.', cardLimit: '노트에는 최대 200장까지 저장할 수 있습니다.',
    lockedLocales: '기존 개인 노트의 질문 언어와 학습 언어는 변경할 수 없습니다.',
    detect: '언어 추천', detecting: '언어를 확인하는 중…', defaultLocale: '판별하지 못한 언어는 현재 선택을 유지했어요. 선택된 언어를 확인해 주세요.',
    saveFailed: '저장하지 못했습니다. 초안은 유지됩니다. 다시 시도해 주세요.',
    pendingText: '입력한 텍스트를 카드로 추가하거나 텍스트를 지운 뒤 저장해 주세요.',
    loadFailed: '노트를 불러오지 못했습니다.', retry: '다시 시도', editHelp: '포인트와 반복 횟수를 유지하면서 내용을 수정합니다.',
    appendOnly: '이 노트에 새 카드를 추가합니다. 기존 카드와 노트 설정은 유지됩니다.',
    cancelTitle: '수정 내용을 취소할까요?', cancelHelp: '저장하지 않은 변경 사항만 사라집니다. 기존 노트는 그대로 유지됩니다.',
    discard: '수정 취소', keepEditing: '계속 편집', confirmSave: '확인 후 저장',
    noDescription: '설명 없음', coverChanged: '선택한 표지가 저장됩니다', coverRemoved: '현재 표지가 삭제됩니다',
  },
};

export function editorText(key, language = getLanguage()) {
  return messages[language === 'ko' ? 'ko' : 'en'][key] || key;
}
